import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ElementRef,
} from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../../../environments/environment";
import { ValidatorHelper } from "../../helpers";

import Swal from "sweetalert2";

@Component({
  selector: "app-list",
  templateUrl: "./list.component.html",
  styleUrls: ["./list.component.scss"],
})
export class ListComponent implements OnInit {
  api = environment.api;

  @Input() dataList;
  @Input() currentUrl;
  @Input() link;
  @Input() currencyColumn;

  @Output() callback = new EventEmitter();

  constructor(
    private router: Router,
    private http: HttpClient,
    private elementRef: ElementRef,
    private validator: ValidatorHelper
  ) {}

  ngOnInit() {}

  view(url, id) {
    this.router.navigate([`${url}/view/${id}`]);
  }

  edit(url, id) {
    this.router.navigate([`${url}/edit/${id}`]);
  }

  delete(url, id) {
    this.http.delete(this.api + `/${url}/${id}`).subscribe((response) => {
      Swal({
        title: "Tem certeza que deseja deletar este registro?",
        confirmButtonText: "Sim, obrigado!",
        confirmButtonClass: "sweet-button",
        showCancelButton: true,
        cancelButtonText: "Não, me equivoquei!",
        cancelButtonClass: "sweet-button-cancel",
        buttonsStyling: false,
      }).then(() => {
        this.validator.errorLoaded = true;

        this.http
          .delete(this.api + `/${url}/+${id}`)
          .subscribe((response) => {
            Swal({
              type: "success",
              title: "Registro deletado!",
            }).then(() => {
              location.reload();
            });
          })
          .add(() => {
            this.validator.errorLoaded = false;
          });
      });
    });
  }

  approved(url, id) {
    Swal({
      title: "Tem certeza que deseja aprovar este registro?",
      confirmButtonText: "Sim, obrigado!",
      confirmButtonClass: "sweet-button",
      showCancelButton: true,
      cancelButtonText: "Não, me equivoquei!",
      cancelButtonClass: "sweet-button-cancel",
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.validator.errorLoaded = true;

        let raw = {
          idFsRequisicao: `${id}`,
        };

        this.http
          .put(this.api + `/${url}`, raw)
          .subscribe((response) => {
            Swal({
              type: "success",
              title: "Registro aprovado!",
              confirmButtonText: "Obrigado!",
              confirmButtonClass: "sweet-button",
              buttonsStyling: false,
            }).then(() => {
              this.callback.emit(true);
            });
          })
          .add(() => {
            this.validator.errorLoaded = false;
          });
      }
    });
  }

  disapproved(url, id) {
    Swal.mixin({
      confirmButtonClass: "sweet-button",
      cancelButtonClass: "sweet-button-cancel",
      showCancelButton: true,
      buttonsStyling: false,
      progressSteps: ["1", "2"],
    })
      .queue([
        {
          title: "Tem certeza que deseja reprovar este registro?",
          text: "Escreva o motivo abaixo.",
          input: "textarea",
          confirmButtonText: "Sim, próximo passo",
          cancelButtonText: "Não, me equivoquei!",
          inputValidator: (value) => {
            if (!value) {
              return "Justifique o motivo da reprovação!";
            }
          },
        },
        {
          title: "Para quem deseja enviar a notificação de reprovação?",
          confirmButtonText: "Ok, enviar",
          cancelButtonText: "Não, cancelar",
          input: "radio",
          inputOptions: { loja: "Loja", tecnico: "Técnico" },
          inputValidator: (value) => {
            if (!value) {
              return "Selecione uma opção!";
            }
          },
        },
      ])
      .then((result) => {
        if (result.value) {
          this.validator.errorLoaded = true;
          if (result.value[1] === "loja") {
            let raw = {
              idFsRequisicao: `${id}`,
              dsObservacao: result.value[0],
            };

            this.http
              .put(this.api + `/${url}`, raw)
              .subscribe((response) => {
                Swal({
                  type: "success",
                  title: "Registro reprovado!",
                  confirmButtonText: "Obrigado!",
                  confirmButtonClass: "sweet-button",
                  buttonsStyling: false,
                }).then(() => {
                  this.callback.emit(true);
                });
              })
              .add(() => {
                this.validator.errorLoaded = false;
              });
          } else if (result.value[1] === "tecnico") {
            let raw = {
              idFsRequisicao: `${id}`,
              dsObservacao: result.value[0],
            };

            this.http
              .put(this.api + `/aprovacao-ordem-servico/retornar-tecnico`, raw)
              .subscribe((response) => {
                this.validator.errorLoaded = true;

                Swal({
                  type: "success",
                  title: "Registro reprovado!",
                  confirmButtonText: "Obrigado!",
                  confirmButtonClass: "sweet-button",
                  buttonsStyling: false,
                }).then(() => {
                  this.callback.emit(true);
                });
              })
              .add(() => {
                this.validator.errorLoaded = false;
              });
          }
        }
      });
  }

  openModal(id) {
    this.callback.emit(id);
  }

  row(event, ref) {
    event.target.children[0].classList.toggle("icn-arrow-down");
    event.target.children[0].classList.toggle("icn-arrow-right");

    this.elementRef.nativeElement
      .querySelector(`.${ref}`)
      .classList.toggle("show");
  }
}
